import React from 'react';
import '../../App.css';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Post1 from '../../data/posts/Hello_World';
import Post2 from '../../data/posts/btc';

const BlogPost = () => {
    const { postId } = useParams();
    let post;
  
    // Decide which post to show based on the postId
    if (postId === 'hello-world') {
      post = Post1;
    } else if (postId === 'btc') {
      post = Post2;
    }
  
    return (
        <div className="blog-content">
        {post ? (
          <div className="terminal-window">
            <div className="terminal-header">
              <span className="terminal-title">C12://BLOG/{postId.toUpperCase()}</span>
              <div className="terminal-controls">
                <span className="terminal-control">_</span>
                <span className="terminal-control">□</span>
                <span className="terminal-control">×</span>
              </div>
            </div>
            <div className="terminal-content">
              <p className="terminal-line">
                <span className="terminal-prompt">$</span> cat {post.title}.md
              </p>
              <div style={{ marginTop: '2rem' }}>
                <h1 style={{ color: 'var(--terminal-cyan)', marginBottom: '0.5rem' }}>{post.title}</h1>
                <p style={{ color: 'var(--terminal-gray)', marginBottom: '2rem' }}>
                  <span className="terminal-prompt">#</span> {post.date}
                </p>
                <div dangerouslySetInnerHTML={{ __html: post.content }} />
              </div>
              <div className="terminal-input" style={{ marginTop: '3rem' }}>
                <Link to="/blog">
                  <button className="terminal-button" style={{ marginRight: '1rem' }}>[BACK]</button>
                </Link>
                <Link to="/">
                  <button className="terminal-button">[HOME]</button>
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <div className="terminal-window">
            <div className="terminal-header">
              <span className="terminal-title">C12://ERROR</span>
              <div className="terminal-controls">
                <span className="terminal-control">_</span>
                <span className="terminal-control">□</span>
                <span className="terminal-control">×</span>
              </div>
            </div>
            <div className="terminal-content">
              <p className="terminal-line" style={{ color: 'var(--terminal-red)' }}>
                <span className="terminal-prompt">!</span> Error: Post not found
              </p>
              <p className="terminal-line">
                <span className="terminal-prompt">$</span> ls: cannot access '{postId}': No such file or directory
              </p>
              <div className="terminal-input">
                <Link to="/blog">
                  <button className="terminal-button">[BLOG]</button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
  
  export default BlogPost;